























































































import { computed, ref, defineComponent, watch, reactive } from '@vue/composition-api';
import {
  LoadingIcon,
  CheckCircleFilledIcon,
  ErrorCircleFilledIcon,
  HelpCircleIcon,
  FileCopyIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';

import i18n, { i18n_t } from '@/locales/i18n';
import { httpUrl } from '@/renderer/scripts/http';
import tips from '@/renderer/scripts/utils/tips';

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      requred: true,
      type: Object,
      default: () => {
        return {
          redirectUri: '',
          loginFlag: '',
          ssoEndpoint: '',
          userInfoEndpoint: '',
        };
      },
    },
    testResult: {
      type: String,
      required: true,
      default: '',
    },
  },
  components: {
    LoadingIcon,
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
    RemoveConfigConfirm,
    HelpCircleIcon,
    FileCopyIcon,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const casFormData = reactive<any>({
      redirectUri: '',
      loginFlag: 'user',
      ssoEndpoint: '',
      userInfoEndpoint: '',
      isCreateAccountOnLogin: false,
    });

    const isCreate = computed(() => Object.keys(props.initData).some(key => _.isEmpty(props.initData[key])));

    const rules = {
      loginFlag: [
        {
          required: true,
          message: i18n_t('登录名字段必填'),
          type: 'error',
        },
      ],

      ssoEndpoint: [
        {
          required: true,
          message: i18n_t('CAS server必填'),
          type: 'error',
        },
        {
          url: {
            protocols: ['http', 'https'],
            require_protocol: true,
          },
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
      ],

      userInfoEndpoint: [
        {
          required: true,
          message: i18n_t('CAS Ticket校验地址必填'),
          type: 'error',
        },
        {
          url: {
            protocols: ['http', 'https'],
            require_protocol: true,
          },
          message: i18n_t('仅支持url格式'),
          type: 'error',
        },
      ],
    };

    const methods = {
      async copyText(text: string) {
        try {
          await copyText2Clipboard(text);
          tips.success(i18n_t('复制成功'));
        } catch (e: any) {
          tips.error(e);
        }
      },
      init() {
        Object.assign(casFormData, props.initData);
        if (_.isEmpty(props.initData.redirectUri)) {
          casFormData.redirectUri = `${httpUrl.webUrl}/login`;
        }
      },
      onClose() {
        const casForm = context.refs.casForm as any;
        casForm.clearValidate();
        innerShow.value = false;
      },
      async testConfig() {
        const casForm = context.refs.casForm as any;
        const result = await casForm.validate();
        if (result === true) {
          context.emit('testConfig', { protocol: 'cas', config: casFormData });
        }
      },
      async saveConfig() {
        const casForm = context.refs.casForm as any;
        const result = await casForm.validate();
        if (result === true) {
          context.emit('saveConfig', { protocol: 'cas', config: casFormData });
        }
      },
      confirmRemove() {
        context.emit('removeProtocol', 'cas');
        innerShow.value = false;
      },
      throttleValidateConfigForm: _.throttle(() => {
        const isDiff = Object.keys(props.initData).some(key => props.initData[key] !== casFormData[key]);
        if (isDiff) {
          context.emit('update:testResult', '');
        }
      }, 500),
    };

    watch(
      () => innerShow.value,
      val => {
        if (val) {
          methods.init();
        }
      },
    );

    return {
      innerShow,
      casFormData,
      rules,
      isCreate,
      ...methods,
    };
  },
});
